// extracted by mini-css-extract-plugin
export var productImage = "_xp-0";